import React from "react";
import "./styles.scss";
import TweetBox from "./TweetBox";
import NewsfeedVideo from "./NewsfeedVideo";
import NewsfeedToggleTab from "./NewsfeedToggleTab";
import ActivityFilters from "./ActivityFilters";
import { fetchTimeline, indexPosts } from "../../../api/posts";
import { newsfeedVideo } from "../../../api/newsfeed_video";
import { log_error } from "../../../api";
import MusicGenres from "../../App/shared/MusicGenres";
import { Spinner } from "react-bootstrap";
import PostsList from "../PostsList";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
// import Distribution from "../../App/Distribution";
import PrimoSubscriptionModal from "../shared/PrimoSubscriptionModal";

const tabs = [
  {
    id: 1,
    value: "following",
    label: "FOLLOWING",
  },
  {
    id: 2,
    value: "genres_you_like",
    label: "IN GENRES YOU LIKE",
  },
  {
    id: 3,
    value: "newest_posts",
    label: "ALL NEWEST POSTS",
  },
];

const theLatestTab = tabs.find((tab) => tab.value === "newest_posts");

export default class NewsFeed extends React.Component {
  state = {
    posts: [],
    errors: null,
    loadingMore: false,
    hasMorePosts: true,
    page: 0,
    pageSize: 15,
    activeTab: tabs[0],
    isSticky: false,
    subscribeModal: false,
  };

  isBottom = (el) => {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  };

  // autoPlayVideoWithenBoundries = () => {
  //   const videos = document.querySelectorAll('#timeline .timeline-video');
  //   videos.forEach((video) => {
  //     const observer = new IntersectionObserver(
  //       (entries) => {
  //         const entery = entries[0];
  //         if (!entery.isIntersecting) {
  //           video.pause();
  //         } else {
  //           video.play();
  //         }
  //       },
  //       {
  //         root: null,
  //         rootMargin: '50px',
  //         threshold: 0.5,
  //       }
  //     );
  //     observer.observe(video);
  //   });
  // };

  onScroll = (e) => {
    // NOTE: need to skip these block for mobile device.
    if (isMobile || window.innerWidth < 992) return;
    const wrappedElement = document.getElementById("newsfeed-page");
    const tabsContainer = document.getElementsByClassName("newsfeed-toggles");
    if (e.target.scrollTop >= tabsContainer[0].offsetTop) {
      if (!this.state.isSticky) this.setState({ isSticky: true });
    } else {
      if (this.state.isSticky) this.setState({ isSticky: false });
    }
    if (this.isBottom(wrappedElement) && this.state.page !== 0 && this.state.hasMorePosts && !this.state.loadingMore) {
      this.indexPosts();
    }
  };

  addScrollEventHandler = () => {
    window.addEventListener("scroll", this.onScroll, true);
  };
  removeScrollEventHandler = () => {
    window.removeEventListener("scroll", this.onScroll, true);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.filter && this.props.filter.author_id !== prevProps.filter.author_id) {
      this.indexPosts();
    }
  }

  getFeed = async (filters) => {
    if (this.state.activeTab.value === "genres_you_like") {
      return await indexPosts({
        filter: { ...filters },
        page_number: this.state.page,
        page_size: this.state.pageSize,
      });
    } else if (this.state.activeTab.value === "newest_posts") {
      return await indexPosts({
        page_number: this.state.page,
        page_size: this.state.pageSize,
      });
    } else {
      // this could be following or any thing else
      return await fetchTimeline({
        filter: { ...filters },
        page_number: this.state.page,
        page_size: this.state.pageSize,
      });
    }
  };

  indexPosts = async (filters = {}) => {
    try {
      if (this.state.page !== 0) {
        this.setState({ loadingMore: true });
      }
      let {
        data: { posts },
      } = await this.getFeed(filters);
      this.setState((prevState) => {
        return {
          posts: Array.isArray(prevState.posts) ? [...prevState.posts, ...posts] : posts,
          page: prevState.page + 1,
          hasMorePosts: posts.length >= prevState.pageSize,
        };
      });
      // this.autoPlayVideoWithenBoundries();
    } catch (error) {
      let errors = log_error(error);
      this.setState({ errors });
    } finally {
      this.setState({ loadingMore: false });
    }
  };

  onPostCreated = (post) => {
    this.setState({
      posts: [post, ...this.state.posts],
    });
    this.onTabChange(theLatestTab);
  };
  onFilterClick = (value) => {
    this.indexPosts(value);
  };
  postsSetter = (newPost) =>
    this.setState({
      posts: this.state.posts.map((post) => (newPost.id === post.id ? newPost : post)),
    });
  postsDeleter = (id) =>
    this.setState({
      posts: this.state.posts.filter((post) => id !== post.id),
    });

  onTabChange = async (tab) => {
    await this.setState({ posts: [], page: 0, activeTab: tab });
    if (tab.value === "genres_you_like") {
      const genres = this.props.user.music_interests;
      const filter = { tags: genres };
      this.indexPosts(filter);
    } else this.indexPosts();
  };

  getNewsfeedVideo = async () => {
    try {
      let response = await newsfeedVideo();
      this.setState({ newsfeedVideo: response.data });
    } catch (error) {
      console.log(log_error(error));
    }
  };

  setAtiveTab = (tab) => {
    if (tab.value === this.state.activeTab.value || this.state.page === 0) return;
    this.setState({ activeTab: tab });
    this.onTabChange(tab);
  };

  setSubscribeModal = () => {
    this.setState({ subscribeModal: false });
  };

  componentDidMount() {
    if (this.props.location.search == "?primo=true") {
      this.setState({ subscribeModal: true });
    }

    this.addScrollEventHandler();
    this.indexPosts();
    this.getNewsfeedVideo();
  }

  componentWillUnmount() {
    this.removeScrollEventHandler();
  }

  render() {
    return (
      <div className={isMobile ? "container-fluid" : ""}>
        <div
          id="newsfeed-page"
          className={`newsfeed ${(this.props.className ? this.props.className : "", this.state.activeTab.value.split("_").join("-"))}`}
        >
          {isMobile ? <h1 className="my-4">Newsfeed</h1> : ""}
          {this.props.tweetBox && <TweetBox onPostCreated={this.onPostCreated} />}
          {this.state.newsfeedVideo && !this.state.newsfeedVideo.error && (
            <NewsfeedVideo videoUrl={this.state.newsfeedVideo.embed_url} videoDescription={this.state.newsfeedVideo.description} />
          )}
          {this.props.showTabsToggle && (
            <div className="newsfeed-toggles d-flex my-4">
              {tabs.map((tab, index) => (
                <NewsfeedToggleTab
                  tab={tab}
                  isSticky={this.state.isSticky}
                  setAtiveTab={this.setAtiveTab}
                  isActive={index === tabs.indexOf(this.state.activeTab)}
                />
              ))}
            </div>
          )}

          {this.props.activityFilters && <ActivityFilters onFilterClick={this.onFilterClick} user={this.props.user} />}
          {this.props.musicGenres && <MusicGenres defaultChecked={[]} onChange={(tags) => this.indexPosts({ tags })} noWrap />}
          <PostsList
            showCommets={false}
            user={this.props.user}
            refresh={this.indexPosts}
            posts={this.state.posts}
            postsSetter={this.postsSetter}
            postsDeleter={this.postsDeleter}
          />
          {this.state.loadingMore && (
            <div className="text-center">
              <Spinner as="span" animation="border" size="md" variant="light" style={{ marginRight: 20 }} />
            </div>
          )}

          {this.props.showTabsToggle && !this.state.hasMorePosts ? (
            <div className="py-5 d-flex flex-column text-center bottom-message">
              {this.props.user.followings_count === 0 ? (
                <div className="has-no-following mb-3">
                  You’re not following anyone! Discover new artists to connect with in <a href="/the-latest">The Latest</a> or{" "}
                  <a href="/browse">Now Charting</a>.
                </div>
              ) : (
                <div className="text-muted mb-3">... And that’s all for now!</div>
              )}
              <div>
                {this.state.activeTab.value === "genres_you_like" || this.state.activeTab.value === "following" ? (
                  <button type="btn" className="btn btn-primary mx-3 px-4 py-2" onClick={() => this.setAtiveTab(theLatestTab)}>
                    SEE NEW POSTS
                  </button>
                ) : (
                  <Link type="btn" className="btn btn-primary mx-3 px-4 py-2" to="/the-latest">
                    SEE THE LATEST
                  </Link>
                )}
              </div>
            </div>
          ) : null}
        </div>
        {/*<Distribution />*/}
        {this.state.subscribeModal && (
          <PrimoSubscriptionModal
            showModal={this.state.subscribeModal}
            setSubscribeModal={this.setSubscribeModal}
            hash={false}
            showDistributingInfo={false}
          />
        )}
      </div>
    );
  }
}
